import * as React from "react";
import Component from "../../AbstractComponent";
// import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
// import RadioGroup from '@material-ui/core/RadioGroup';
// import Radio from '@material-ui/core/Radio';
import TextField from "../Material/TextField";
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';
import ContractLookup from "../Lookup/ContractLookup";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import Constants from "../../../Action/Constants";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
// import { PromptDialog } from "./PromptDialog";
import CurrencyContainer from "../../../Currency/CurrencyContainer";
import { PageTransition } from "../Spinner/PageTransition";

import Time from "../../../Time/Time";
import Formatter from "../../../Localization/Formatter";
import * as uuidV4 from "uuid/v4";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { ContactForContractInterface } from "../../../Entity/Entities/ContactForContract/ContactForContractInterface";
import { ContractInterface } from "Casadesk/Entity/Entities/Contract/ContractInterface";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import { FirstDayOfPeriod } from "../../../Entity/Entities/Charge/PaymentOffset/Offsets/FirstDayOfPeriod";

import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "./NewCoach/NewCoachContents/CoachSummaryTable";

export class CoachIncreaseRentDialog extends Component {
  private shortContractWarningPeriod: number = 1000 * 60 * 60 * 24 * 5;

  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCoachIncreaseRent: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: null,
    selectedUnit: null,
    amazonFolderName: uuidV4(),
    firstName: "",
    tenantChoice: "newtenant",
    lastName: "",
    tenantType: "person",
    tenant: null,
    tenantFirstName: "",
    tenantLastName: "",
    companyNameTenant: "",
    companyTenant: null,
    disableNextButton: true,
    isSaving: false,
    isClosePreprocessDialogOpen: false,
    successfullyUpdated: false,

    //Occupant data
    occupantFirstName: "",
    occupantLastName: "",
    occupantDescription: this.trans("label-occupant"),
    occupantError: null,
    occupantsData: [],
    showAdditionalSection: false,
    defaultAgencyFees: [],

    //Contract data
    contract: null,
    finalRentalPeriodDate: null,
    expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.props.app.settings.agency.notificationPeriod),
    rentNotificationText1: this.props.rentNotificationText1 || this.trans("notification_rent_message"),
    rentNotificationText2: this.props.rentNotificationText2 || this.trans("notification_adjust_rent_message"),
    lastDate: Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()),
    status: this.props.app.contractStatuses['CONCEPT'],
    note: "",
    firstDate: Time.isBefore(this.props?.contract?.firstDate, new Date()) ? Time.firstDateNextMonth() : Time.firstDateNextMonthfromDate(this.props?.contract?.firstDate),
    endDate: null,
    isSetPaymentUntilDateChecked: false,
    payChargesUntilDate: Time.lastDatePreviousMonth(),
    additionalFields: [],
    autoSendInvoiceToTenant: false,
    addressForRentEmail: "",
    isCommercial: false,
    selectedTenant: null,
    newContract: null,

    //Charge template data
    chargeTemplates: [],
    initialChargeTemplates: [],
    newChargeTemplates: [],
    isChargeTemplatePopupOpen: false,
    newChargeTemplatePopupOpen: null,
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null,
    isCalculatePriceFieldsShow: null,
    priceOldAmount: "",
    priceNewAmount: "",
    pricePercentage: "0",
    chargeTemplateInitialAmounts: {},
    selectedChargeIndex: null,

    datepickerHint: this.trans("last-date-of-period-pretty-close"),
    datepickerError: "",
    extensionDate: Time.isBefore(this.props?.contract?.firstDate, new Date()) ? Time.firstDateNextMonth() : Time.firstDateNextMonthfromDate(this.props?.contract?.firstDate),
    error: null,
    tooltipOpen: false,
    disabledNext: true
  };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      openCoachIncreaseRent: this.props?.openCoachIncreaseRent,
    });
    if (this.props.contract) {
      let chargeTemplates = [];

      this.props.contract?.chargeTemplates
        .filter((chargeTemplate: ChargeTemplateInterface) => {
          return !!chargeTemplate && (chargeTemplate?.type?.id !== TypeContainer.pickIdFromLabel("Deposit"));
        })
        .forEach(template => {

          let chargeTemplate = {
            amount: parseFloat(Formatter.simpleFormatNumber(template?.amount).replace(",", ".")),
            currency: template?.currency?.getCurrencyId(),
            type: template?.type?.id,
            repeatPeriod: template?.repeatPeriod?.id,
            description: template?.description,
            paymentOffset: template?.paymentOffset?.getValue(),
            dueDateFirstPayment: Time.firstDateNextMonth(),
            firstDate: Time.isBefore(this.props?.contract?.firstDate, new Date()) ? Time.firstDateNextMonth() : Time.firstDateNextMonthfromDate(this.props?.contract?.firstDate),
            endDate: null,
            isDefault: false,
            oldAmount: parseFloat(Formatter.simpleFormatNumber(template?.amount).replace(",", ".")),
            // isDummyPay: template?.isDummyPay,
            contactId: template?.contactId,
            companyId: template?.companyId,
            isCollective: template?.isCollective,
            id: template?.id,
            percentage: "0",
            editedAmount: parseFloat(Formatter.simpleFormatNumber(template.amount)),
            buttonDisabled: true,
            isPaidDirectlyToOwner: template?.isPaidDirectlyToOwner
          }

          chargeTemplates.push(chargeTemplate);
        });

      this.setState({
        activeStep: 1,
        contract: this.props?.contract,
        chargeTemplates: [...chargeTemplates],
        initialChargeTemplates: [...chargeTemplates],
        extensionDate: Time.isBefore(this.props?.contract?.firstDate, new Date()) ? Time.firstDateNextMonth() : Time.firstDateNextMonthfromDate(this.props?.contract?.firstDate),
        lastDate: this.props?.contract?.lastDate,
        finalRentalPeriodDate: this.props?.contract?.finalRentalPeriodDate,
        expirationDate: Time.nextYearPrevMonthLastDay(Time.substractMonth(Time.nextDayFromDate(this.state.firstDate), this.props.app.settings.agency.notificationPeriod - 1)),
      });
    }
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCoachIncreaseRent: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: null,
      selectedUnit: null,
      amazonFolderName: uuidV4(),
      firstName: "",
      tenantChoice: "newtenant",
      lastName: "",
      tenantType: "person",
      tenant: null,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: "",
      companyTenant: null,
      disableNextButton: true,
      isSaving: false,
      isClosePreprocessDialogOpen: false,
      successfullyUpdated: false,

      //Occupant data
      occupantFirstName: "",
      occupantLastName: "",
      occupantDescription: this.trans("label-occupant"),
      occupantError: null,
      occupantsData: [],
      showAdditionalSection: false,

      //Contract data
      contract: null,
      finalRentalPeriodDate: null,
      expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.props.app.settings.agency.notificationPeriod),
      lastDate: Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()),
      status: this.props.app.contractStatuses['CONCEPT'],
      note: "",
      firstDate: Time.isBefore(this.props?.contract?.firstDate, new Date()) ? Time.firstDateNextMonth() : Time.firstDateNextMonthfromDate(this.props?.contract?.firstDate),
      endDate: null,
      isSetPaymentUntilDateChecked: false,
      payChargesUntilDate: Time.lastDatePreviousMonth(),
      additionalFields: [],
      autoSendInvoiceToTenant: false,
      addressForRentEmail: "",
      isCommercial: false,
      selectedTenant: null,
      newContract: null,

      chargeTemplates: [],
      isChargeTemplatePopupOpen: false,
      newChargeTemplatePopupOpen: null,
      anchorElChargeTemplate: null,
      selectedChargeTemplate: null,
      isCalculatePriceFieldsShow: null,
      priceOldAmount: "",
      priceNewAmount: "",
      pricePercentage: "0",
      chargeTemplateInitialAmounts: {},
      selectedChargeIndex: null,

      extensionDate: Time.isBefore(this.props?.contract?.firstDate, new Date()) ? Time.firstDateNextMonth() : Time.firstDateNextMonthfromDate(this.props?.contract?.firstDate),
      error: null
    });
  }

  public onCloseIncreaseRentCoach = () => {
    this.clearBackEndErrors();
    setTimeout(() => { this.clearState() }, 100);

    if (this.props.onCloseIncreaseRentCoach) {
      this.props.onCloseIncreaseRentCoach.call(this, this.state.newContract, this.state.successfullyUpdated);
    }
  }

  /* Logic for open other coaches */
  public openUnitCoachDialog = () => {
    if (this.props.openUnitCoachDialog) {
      this.props.openUnitCoachDialog.call(this);
    }
  }

  public renewContract = () => {

    const payload: any = {
      сreatedOnFrontend: true,
      id: this.state.contract?.id,
      unit: this.state.contract?.unit,
      amazonFolderName: this.state.amazonFolderName,
      extensionDate: this.state.extensionDate,
      lastDate: this.state.lastDate,
      finalRentalPeriodDate: this.state.finalRentalPeriodDate,
      endDate: this.state.endDate,
      expirationDate: this.state.expirationDate,
      // text: this.state.rentNotificationText,
      payChargesUntilDate: this.state.isSetPaymentUntilDateChecked === true ? this.state.payChargesUntilDate : null,
      note: this.state?.contract?.note,
      chargeTemplates: this.state.chargeTemplates
        .filter((chargeTemplate: ChargeTemplateInterface) => !chargeTemplate?.unitId),
      additionalFields: this.state.contract?.contractParties
        .map((contactForContract: ContactForContractInterface) => {
          return {
            selectedPerson: contactForContract.person,
            description: contactForContract.description,
            contactForContractTypeId: contactForContract.type.getValue()
          };
        }),
      agencyFee: this.state?.contract?.defaultAgencyFees[0],
      autoSendInvoiceToTenant: this.state?.contract?.autoSendInvoiceToTenant,
      isCommercial: this.state?.contract?.isCommercial,
    };

    if (this.state?.contract?.tenant instanceof Person) {
      payload.selectedPerson = this.state?.contract?.tenant;
    }

    if (this.state?.contract?.tenant instanceof Company) {
      payload.selectedCompany = this.state?.contract?.tenant;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_EXTEND_START,
        payload: {
          ...payload
        },
        onSuccess: (contract) => {
          this.setState({
            error: null,
            isSaving: false,
            activeStep: 4,
            successfullyUpdated: true,
            newContract: contract
          })
        },
        onError: (err) => {
          const showAgencyFeeErrorDialog = err.fields.some(field => field === "agencyFee.percentageFee")
          const showChargeTemplateErrorDialog = err.fields.some(field => field.indexOf("chargeTemplates") === 0)
          const showExtentionDateErrorDialog = err.fields.some(field => field.indexOf("extensionDate") === 0)
          let chargeTemplatesErrorRows = [];

          let chargeTemplatesErrorIndexRows = err.fields.filter(field => field.indexOf("chargeTemplates") === 0)
            .map(field => parseInt(field.match(/\d+/)));

          let chargeTemplatesError = err.fields.filter(field => field.indexOf("chargeTemplates") === 0)
          let chargeTemplatesErrorField;
          if (chargeTemplatesError.length && chargeTemplatesError[0]) {
            chargeTemplatesErrorField = chargeTemplatesError[0].split(".")
          }


          chargeTemplatesErrorRows.push(chargeTemplatesErrorIndexRows[0]); // just set first error from array
          const chargeTemplates = this.state.chargeTemplates.map((chargeTemplate, index) => {
            return {
              ...chargeTemplate,
              error: chargeTemplatesErrorRows.some(field => field === index)
            }
          })

          this.setState({
            chargeTemplates: chargeTemplates,
            isSaving: false,
            hasModifiedData: true,
            error: err,
            activeStep: err?.errorId === "be_last_earlier_than_first_date" ? 2 : 3
          })

          if (showAgencyFeeErrorDialog) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("error-notvaliddatata-agencyfee"),
                type: "error"
              }
            });
          }

          if (showChargeTemplateErrorDialog) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("error-notvaliddatata-chargetemplate", { field: this.trans(`label-${chargeTemplatesErrorField[1]}`) }),
                type: "error"
              }
            });
          }
          if (showExtentionDateErrorDialog) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("notification_period_warning"),
                type: "error"
              }
            });
          }
        }
      });
    });
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [
      this.trans("coach/increaserent-step/first-title"),
      this.trans("coach/increaserent-step/second-title"),
      this.trans("coach/increaserent-step/third-title"),
      this.trans("summary"),
      this.trans("menuitem-finish"),
    ];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      case 3:
        return this.stepContent(step);
      case 4:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
        {step === 3 && this.fourthStepDetails()}
        {step === 4 && this.fifthStepDetails()}
      </div>
    )
  }

  // Steppers components content
  public firstStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/renew-contract-step/step1-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/increaserent-step/step1-hint")}
        />
        <div>
          <ContractLookup
            {...this.props}
            id="contractId"
            name="contractId"
            ref="ContractLookup"
            className="scroll-to-contractId"
            styleInModal={"styleInModal"}
            disableEntityCreation={true}
            onSelect={this.selectContract}
            onClear={this.clearContract}
            autoFocus={false}
            hideClickThroughLink={true}
            filterSignedAndExpiring={true}
            autoSelectId={this.state.contract?.id}
          />
        </div>
      </div>
    )
  }

  public secondStepDetails = () => {
    return (
      <div className="coach-content-wrapper" style={{ width: "650px", maxWidth: "unset" }}>
        <Title
          title={this.trans("coach/increaserent-step2/title")}
        />
        <Subtitle
          subtitle={this.trans("coach/increaserent-step2/subtitle", { unitDisplayName: this.state.contract?.unit?.shortDisplayName || this.state.contract?.unit?.displayName })}
        />
        <div style={{ display: "flex", flexDirection: "column" }}>
          {this.state.chargeTemplates?.length > 0 &&
            <ul style={{ margin: 0, width: "100%", padding: 0 }}>
              {
                this.state.chargeTemplates?.map((chargeTemplate, index) => {
                  return (
                    <>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "baseline", width: "100%", marginBottom: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "auto", position: "relative" }}>
                          <li style={{ margin: "0", listStyle: "none", fontSize: "16px" }}> {chargeTemplate.error &&
                            <span style={{ position: "absolute", left: "-40px", top: "2px" }}>
                              <span
                                className="icon icon-ic-info red"
                              >
                              </span>
                            </span>
                          }{`${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system)}, ${this.formatter.formatNumber(chargeTemplate.oldAmount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}${chargeTemplate?.isChanged ? ", " : ""}`}
                            {chargeTemplate.isChanged ? <span style={{ color: "green", fontSize: "16px" }}>{this.trans("title-new")}: {this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}</span> : ""}
                          </li>
                          <div
                            className="icon icon-ic-close clear-button"
                            style={{
                              display: "inline-block",
                              position: "absolute",
                              right: "-25px",
                              cursor: "pointer",
                              top: "-1px"
                            }}
                            onClick={this.removeChargeTemplate.bind(this, index)}
                          ></div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div className="form-element full-size no-margins">
                              <TextField
                                autoComplete="off"
                                className="form-element full-size"
                                type="text"
                                label={this.trans("page/renewcontract-dialog/calculateprice-field/oldamount-label")}
                                value={chargeTemplate?.oldAmount}
                                disabled={true}
                                variant="standard"
                                error={false}
                              />
                            </div>

                            <div className="form-element full-size no-margins margin-sides-20">
                              <TextField
                                autoComplete="off"
                                className="form-element full-size"
                                type="text"
                                label={this.trans("page/renewcontract-dialog/calculateprice-field/percentage-label")}
                                onChange={(e) => this.changePricePercentage(e, chargeTemplate?.id)}
                                value={chargeTemplate?.percentage}
                                variant="standard"
                                error={false}
                              />
                            </div>

                            <div className="form-element full-size no-margins">
                              <TextField
                                autoComplete="off"
                                className="form-element full-size scroll-to-amount"
                                type="text"
                                label={this.trans("page/renewcontract-dialog/calculateprice-field/newamount-label")}
                                value={chargeTemplate?.editedAmount}
                                onChange={(e) => this.changePriceNewAmount(e, chargeTemplate?.id)}
                                autoFocus={index === 0}
                                variant="standard"
                                error={!!this.getErrorFor("amount")}
                              />
                              {!!this.getErrorFor("amount") && <div className="component-error-text">{this.getErrorFor("amount")}</div>}
                            </div>
                            <Button
                              color="primary"
                              onClick={() => this.updatePrice(chargeTemplate?.id)}
                              variant="contained"
                              disabled={chargeTemplate?.buttonDisabled}
                              style={{ marginLeft: "20px" }}
                            >
                              {this.trans("button-save")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                })
              }
            </ul>
          }
          {this.state.newChargeTemplates?.length > 0 &&
            <ul style={{ margin: 0, width: "100%", padding: 0 }}>
              {
                this.state.newChargeTemplates?.map((chargeTemplate, index) => {
                  return (
                    <>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "baseline", width: "100%", marginBottom: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "auto", position: "relative" }}>
                          <li style={{ margin: "0", listStyle: "none", fontSize: "16px" }}> {chargeTemplate.error &&
                            <span style={{ position: "absolute", left: "-40px", top: "2px" }}>
                              <span
                                className="icon icon-ic-info red"
                              >
                              </span>
                            </span>
                          }{`${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system)}, ${this.formatter.formatNumber(chargeTemplate.oldAmount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}${chargeTemplate?.isChanged ? ", " : ""}`}
                            {chargeTemplate.isChanged ? <span style={{ color: "green", fontSize: "16px" }}>{this.trans("title-new")}: {this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}</span> : ""}
                          </li>
                          <div
                            className="icon icon-ic-close clear-button"
                            style={{
                              display: "inline-block",
                              position: "absolute",
                              right: "-25px",
                              cursor: "pointer",
                              top: "-1px"
                            }}
                            onClick={this.removeNewChargeTemplate.bind(this, index)}
                          ></div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Select
                              className="form-element full-size form-input scroll-to-type correct-label-position"
                              style={{ minWidth: "190px", marginRight: "16px" }}
                              error={this.getErrorFor("type")}
                              value={chargeTemplate?.type}
                              onChange={(event) => this.setChargeTemplateType(event, index)}
                              htmlFor="type"
                              label={this.trans("dialog/defaultchargetemplates-field/type-label")}
                              name="type"
                              id="type"
                            >
                              {
                                TypeContainer.getChargeTypesForChargeTemplates("contract").map((type, index) => {
                                  return (
                                    <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                                  );
                                })
                              }
                            </Select>
                            <div className="form-element full-size no-margins">
                              <TextField
                                autoComplete="off"
                                className="form-element full-size"
                                type="text"
                                label={this.trans("label-amount")}
                                value={chargeTemplate?.editedAmount}
                                onChange={(event) => this.setNewChargeAmount(event, index)}
                                disabled={false}
                                variant="standard"
                                error={false}
                              />
                            </div>

                            <Select
                              className="form-element full-size form-input scroll-to-currency correct-label-position"
                              error={this.getErrorFor("currency")}
                              style={{ margin: "0 16px", maxWidth: "100px" }}
                              value={chargeTemplate?.currency}
                              htmlFor="currency"
                              label={this.trans("dialog/defaultchargetemplates-field/currency-label")}
                              name="currency"
                              id="currency"
                              disabled={true}
                            >
                              {this.getCurrencySelectboxes()}
                            </Select>

                            <Select
                              className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
                              style={{ maxWidth: "110px" }}
                              error={this.getErrorFor("repeat-period")}
                              value={chargeTemplate?.repeatPeriod}
                              onChange={(event) => this.setChargeTemplateRepeatPeriod(event, index)}
                              htmlFor="repeatPeriod"
                              label={this.trans("dialog/defaultchargetemplates-field/period-label")}
                              name="repeatPeriod"
                              id="repeatPeriod"
                            >
                              {this.getRepeatPeriodSelectboxes()}
                            </Select>

                            <Button
                              color="primary"
                              onClick={() => this.saveNewChargeTemplate(index)}
                              variant="contained"
                              disabled={chargeTemplate?.buttonDisabled}
                              style={{ marginLeft: "20px" }}
                            >
                              {this.trans("button-save")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                })
              }
            </ul>
          }
        </div>
        {this.state.newChargeTemplates.length === 0 &&
          <Button
            color="primary"
            onClick={this.addNewChargeTemplate}
            variant="contained"
          >
            {this.trans("button-add")}
          </Button>
        }
      </div>
    );
  }

  public thirdStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/increaserent-step3/title")}
        />
        <Subtitle
          subtitle={this.trans("coach/increaserent-step3/subtitle", { unitDisplayName: this.state.contract?.unit?.shortDisplayName || this.state.contract?.unit?.displayName })}
        />
        <DatePickerComponent
          {...this.props}
          id="firstDate"
          name="firstDate"
          className="scroll-to-extensionDate"
          label={this.trans("first-date")}
          initialDate={this.state.extensionDate}
          onChange={date => this.selectDate(date, "extensionDate")}
          minDate={Time.nextDayFromDate(this.props?.contract?.firstDate)}
          clearButton={false}
          error={this.getErrorFor("extensionDate")}
          width="60%"
        />

        {/* <div style={{ display: "flex", alignItems: "center" }}>
          <DatePickerComponent
            {...this.props}
            id="expirationDate"
            name="expirationDate"
            className="scroll-to-expirationDate"
            label={this.trans("contract-expiration-date") + this.trans("field/optional")}
            initialDate={this.state.expirationDate}
            value={this.state.expirationDate}
            minDate={Time.nextDayFromDate(this.state.extensionDate)}
            minDatePlusDays={0}
            onChange={date => this.selectDate(date, "expirationDate")}
            clearButton={true}
            width="60%"
            error={this.getErrorFor("expirationDate")}
            margin={"7px 0px"}
          />

        </div>
        <div className="hint-styles">
          {this.trans("coach/increaserent-step3/date-hint")}
        </div>
        <TextField
          type="text"
          // value={this.state.rentNotificationText}
          onChange={(e) => this.setState({ rentNotificationText: e.target.value, hasModifiedData: true })}
          label={this.trans("dialog-new-notification-text")}
          style={{width: "60%"}}
        /> */}
      </div>
    )
  }

  public fourthStepSummary = () => {
    let summaryArr = [];
    let listOfChargeTemplates = [...this.state.initialChargeTemplates];
    this.state.chargeTemplates?.forEach(chargeTemplate => {
      if (!chargeTemplate.id) {
        listOfChargeTemplates.push(chargeTemplate);
      }
    });

    if (this.state.contract?.unit?.shortDisplayName || this.state.contract?.unit?.displayName) {
      summaryArr.push({
        label: this.trans("title-unit"),
        value: this.state.contract?.unit?.shortDisplayName || this.state.contract?.unit?.displayName
      });
    }

    if (listOfChargeTemplates?.length > 0) {
      listOfChargeTemplates?.forEach((chargeTemplate, index) => {
        const type = Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system);
        const oldAmount = this.formatter.formatNumber(chargeTemplate.oldAmount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency));
        const amount = this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency));
        const amountEqualOldAmount = chargeTemplate.oldAmount === chargeTemplate.amount;
        summaryArr.push({
          label: index === 0 ? this.trans("title-contract-prices") : "",
          value: <p>{type}&nbsp;{oldAmount}{!amountEqualOldAmount ? <>, <b>{this.trans("title-new").toLowerCase()}</b> {amount}</> : ""}</p>
        });
      })
    }

    if (this.state.extensionDate) {
      summaryArr.push({
        label: this.trans("first-date"),
        value: this.formatter.formatDate(this.state.extensionDate)
      });
    }

    if (this.state.expirationDate) {
      summaryArr.push({
        label: this.trans("contract-expiration-date"),
        value: this.formatter.formatDate(this.state.expirationDate)
      });
    }
    // if (this.state.rentNotificationText) {
    //   summaryArr.push({
    //     label: this.trans("dialog-new-notification-text"),
    //     value: this.state.rentNotificationText
    //   });
    // }

    return summaryArr;
  }

  public fourthStepDetails = () => {
    let listOfChargeTemplates = [...this.state.initialChargeTemplates];
    this.state.chargeTemplates?.forEach(chargeTemplate => {
      if (!chargeTemplate.id) {
        listOfChargeTemplates.push(chargeTemplate);
      }
    })
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/moveunit-step/second-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/general-forelast-update-subtitle-dutch-het", { entity: this.trans("title-contract").toLowerCase() })}
        />
        <div>
          <CoachSummaryTable
            tableRows={this.fourthStepSummary()}
          />
        </div>
      </div>
    )
  }

  public fifthStepDetails = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column", width: "fit-content", margin: "0 auto" }}>
        <Title
          title={this.trans("result")}
        />
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
          {this.image.getAvatar("success", { size: 62 })}
        </div>
        <Subtitle
          subtitle={this.trans("coach/general-summary-update-subtitle-dutch-het", { entity: this.trans("title-contract").toLowerCase() })}
        />
      </div>
    )
  }

  //Funcionality for steps
  public startStep1 = () => {
    return this.contractStartStep1();
  }

  public startStep2 = () => {
    return this.contractStartStep2();
  }

  public startStep3 = () => {
    return this.contractStartStep3();
  }

  public startStep4 = () => {
    return this.renewContract();
  }


  //Methods for step logic
  public contractStartStep1 = () => {
    this.plusOneStep();
  }

  public contractStartStep2 = () => {
    this.plusOneStep();
  }

  public contractStartStep3 = () => {
    this.plusOneStep();
  }

  public contractStartStep4 = () => {
    this.plusOneStep();
  }

  //Methods
  public clearContract = () => {
    this.setState({
      contract: null,
      disableNextButton: true
    });
  }

  public removeChargeTemplate = (index: number): void => {
    const chargeTemplates = [...this.state.chargeTemplates];
    const removedCharge = chargeTemplates.splice(index, 1)[0];
    const editedInitialChargeTemplates = this.state.initialChargeTemplates?.map(chargeTemplate => {
      if (removedCharge.id === chargeTemplate.id) {
        chargeTemplate.amount = 0
      }
      return chargeTemplate
    })

    this.setState({
      chargeTemplates: [...chargeTemplates],
      hasModifiedData: true,
      initialChargeTemplates: [...editedInitialChargeTemplates]
    });
  }

  public removeNewChargeTemplate = (index: number): void => {
    const chargeTemplates = [...this.state.newChargeTemplates];
    chargeTemplates.splice(index, 1);

    this.setState({
      newChargeTemplates: [...chargeTemplates],
      hasModifiedData: true
    });
  }

  public addNewChargeTemplate = (): void => {
    const chargeTemplates = [...this.state.newChargeTemplates];

    let chargeTemplate = {
      amount: "",
      currency: this.props.app.settings.user.currency.getCurrencyId(),
      type: TypeContainer.pickIdFromLabel("Other_receivable"),
      repeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
      description: "",
      paymentOffset: FirstDayOfPeriod.value,
      dueDateFirstPayment: new Date(),
      firstDate: new Date(),
      endDate: null,
      isDefault: false,
      oldAmount: "",
      // isDummyPay: false,
      contactId: null,
      companyId: null,
      isCollective: true,
      percentage: "0",
      editedAmount: "",
      buttonDisabled: true
    }

    chargeTemplates.push(chargeTemplate);

    this.setState({ newChargeTemplates: [...chargeTemplates] });

    // this.forceUpdate();
  }

  public setNewChargeAmount = (event, index: number): void => {
    const amount: string = this.formatter.formatSigns(event.target.value);
    this.setState({
      newChargeTemplates: this.state.newChargeTemplates.map((template, ind) => {
        if (index === ind) {
          return {
            ...template,
            editedAmount: amount,
            buttonDisabled: false
          }
        }
        return template
      })
    })
  }

  public setChargeTemplateType = (event, index: number): void => {
    const type = event.target.value;
    this.setState({
      newChargeTemplates: this.state.newChargeTemplates.map((template, ind) => {
        if (index === ind) {
          const res = {
            ...template,
            type: type,
            repeatPeriod: type === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
            isCollective: type === TypeContainer.pickIdFromLabel("Deposit") ? false : true,
          }
          return res
        }
        return template
      })
    })
  }

  public setChargeTemplateRepeatPeriod = (event, index: number): void => {
    const repeatPeriod = event.target.value;
    this.setState({
      newChargeTemplates: this.state.newChargeTemplates.map((template, ind) => {
        if (index === ind) {
          return {
            ...template,
            repeatPeriod: repeatPeriod,
            isCollective: repeatPeriod === PeriodContainer.pickIdFromLabel("once") ? false : true,
          }
        }
        return template
      })
    })
  }

  public saveNewChargeTemplate = (index: number): void => {
    const chargeTemplate = this.state.newChargeTemplates[index];
    chargeTemplate.amount = parseFloat(parseFloat(String(Formatter.deleteExtraSpace(chargeTemplate.editedAmount)).replace(",", ".")).toFixed(2));
    chargeTemplate.oldAmount = parseFloat(parseFloat(String(Formatter.deleteExtraSpace(chargeTemplate.editedAmount)).replace(",", ".")).toFixed(2));
    chargeTemplate.buttonDisabled = true;
    chargeTemplate.createdOnFrontend = true;
    this.setState({
      newChargeTemplates: this.state.newChargeTemplates.filter((_template, ind) => ind !== index),
      chargeTemplates: [...this.state.chargeTemplates, chargeTemplate],
      disableNextButton: false
    })
  }

  public renderExpirationDateQuicksets = () => {
    return (
      <div className="date-quickset-wrapper">
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 1), "expirationDate")}
        >
          1
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 2), "expirationDate")}
        >
          2
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 4), "expirationDate")}
        >
          4
        </div>
      </div>
    );
  }

  public openTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  public selectContract = (contract: ContractInterface): void => {
    let chargeTemplates = [];

    contract?.chargeTemplates
      .filter((chargeTemplate: ChargeTemplateInterface) => {
        return !!chargeTemplate && (chargeTemplate?.type?.id !== TypeContainer.pickIdFromLabel("Deposit"));
      })
      .forEach(template => {

        let chargeTemplate = {
          amount: parseFloat(Formatter.simpleFormatNumber(template?.amount).replace(",", ".")),
          currency: template?.currency?.getCurrencyId(),
          type: template?.type?.id,
          repeatPeriod: template?.repeatPeriod?.id,
          description: template?.description,
          paymentOffset: template?.paymentOffset?.getValue(),
          dueDateFirstPayment: Time.firstDateNextMonth(),
          firstDate: Time.firstDateNextMonth(),
          endDate: null,
          isDefault: false,
          oldAmount: parseFloat(Formatter.simpleFormatNumber(template?.amount).replace(",", ".")),
          // isDummyPay: template?.isDummyPay,
          contactId: template?.contactId,
          companyId: template?.companyId,
          isCollective: template?.isCollective,
          id: template?.id,
          percentage: "0",
          editedAmount: parseFloat(Formatter.simpleFormatNumber(template.amount)),
          buttonDisabled: true
        }

        chargeTemplates.push(chargeTemplate);
      });
    this.setState({
      contract,
      chargeTemplates,
      disableNextButton: true,
      initialChargeTemplates: chargeTemplates,
      newChargeTemplates: [],
      hasModifiedData: true,
      extensionDate: contract?.firstDate,
      lastDate: contract?.lastDate,
      finalRentalPeriodDate: contract?.finalRentalPeriodDate,
      expirationDate: contract?.expirationDate,
    });
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR,
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public onClear = (index) => {
    const chargeTemplates = this.state.chargeTemplates
    chargeTemplates.splice(index, 1);

    this.setState({
      chargeTemplates: chargeTemplates
    })
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;
    const prevExtensionDate = !!this.state.extensionDate ? new Date(this.state.extensionDate) : null;
    // const prevLastDate = !!this.state.lastDate ? new Date(this.state.lastDate) : null;
    // const prevFinalDate = !!this.state.finalRentalPeriodDate ? new Date(this.state.finalRentalPeriodDate) : null;
    // const prevExpirationDate = !!this.state.expirationDate ? new Date(this.state.expirationDate) : null;

    // Update the state
    this.setState({
      [identifier]: date,
      hasModifiedData: true,
      datepickerHint: "",
      datepickerError: ""
    }, () => {
      // Show the hint if contract period is pretty short, like 5-6 days
      if (!!this.state.extensionDate && !!this.state.lastDate &&
        (this.state.lastDate.getTime() - this.state.extensionDate.getTime()) <= this.shortContractWarningPeriod) {
        this.setState({
          datepickerHint: this.trans("last-date-of-period-pretty-close")
        });
      }

      // when we change first date we also should syncronize value of last date if it wasn't changed manually
      if (identifier === "extensionDate") {
        // we should also update the dates in charge templates
        // Put the current charge templates to the state of the component
        this.setState({
          chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
            let chargeTemplateFirstDate = chargeTemplate?.firstDate;
            let chargeTemplateDueDateFirstPayment = chargeTemplate?.dueDateFirstPayment;

            if (!!this.state.extensionDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.extensionDate;
            }

            if (!this.state.extensionDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.extensionDate;
            }

            if (!!this.state.extensionDate && !prevExtensionDate && !chargeTemplate?.firstDate) {
              chargeTemplateFirstDate = this.state.extensionDate;
            }

            if (!!this.state.extensionDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.extensionDate;
            }

            if (!this.state.extensionDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevExtensionDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.extensionDate;
            }

            if (!!this.state.extensionDate && !prevExtensionDate && !chargeTemplate?.dueDateFirstPayment) {
              chargeTemplateDueDateFirstPayment = this.state.extensionDate;
            }
            return {
              ...chargeTemplate,
              firstDate: chargeTemplateFirstDate,
              dueDateFirstPayment: chargeTemplateDueDateFirstPayment
            }
          })
        });
        return this.selectDate(Time.nextYearPrevMonthLastDay(Time.substractMonth(this.state.extensionDate, this.props.app.settings.agency.notificationPeriod - 1)), "expirationDate");
        // we should update last date if it wasn't changed manually
        // if (!!this.state.extensionDate && !!this.state.lastDate &&
        //   this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevExtensionDate)) === this.formatter.formatDate(this.state.lastDate)) {
        //   return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.extensionDate), "lastDate");
        // }

        // if (!this.state.extensionDate && !!this.state.lastDate &&
        //   this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevExtensionDate)) === this.formatter.formatDate(this.state.lastDate)) {
        //   return this.selectDate(this.state.extensionDate, "lastDate");
        // }

        // if (!!this.state.extensionDate && !prevExtensionDate && !this.state.lastDate) {
        //   return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.extensionDate), "lastDate");
        // }
      }

      // If the identifier is lastDate, we also have to update finalRentalPeriodDate and expirationDate
      // if they were not updated manually
      // if (identifier === "lastDate") {
      //   if (!!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
      //     this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
      //     this.selectDate(this.state.lastDate, "finalDate");
      //   }

      //   if (!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
      //     this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
      //     this.selectDate(date, "finalDate");
      //   }

      //   if (!!this.state.lastDate && !prevLastDate && !prevFinalDate) {
      //     this.selectDate(date, "finalDate");
      //   }

      //   if (!!this.state.lastDate && !!this.state.expirationDate &&
      //     this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
      //     return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
      //   }

      //   if (!this.state.lastDate && !!this.state.expirationDate &&
      //     this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
      //     return this.selectDate(this.state.lastDate, "expirationDate");
      //   }

      //   if (!!this.state.lastDate && !prevLastDate && !prevExpirationDate) {
      //     return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
      //   }
      // }
    });
  }

  public openCalculatePricePopup = (chargeTemplate, index): any => {
    const priceOldAmount = chargeTemplate?.oldAmount ?
      this.formatter.simpleFormatNumber(chargeTemplate?.oldAmount * 100) :
      this.formatter.simpleFormatNumber(chargeTemplate?.amount * 100);

    this.setState({
      selectedChargeIndex: index,
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      isCalculatePriceFieldsShow: chargeTemplate?.id,
      priceOldAmount: priceOldAmount,
      priceNewAmount: this.formatter.simpleFormatNumber(chargeTemplate?.amount * 100)
    });
  }

  public changePriceNewAmount = (event, id): void => {
    const newAmount: string = this.formatter.formatSigns(event.target.value);
    const newTemplateArr = this.state.chargeTemplates?.map(template => {
      if (template?.id === id) {
        template.editedAmount = newAmount;
        template.buttonDisabled = false;
      }
      return template
    })
    this.setState({
      chargeTemplates: newTemplateArr
    });
  }

  public changePricePercentage = (event, id): void => {
    const percentage: string = this.formatter.formatSigns(event.target.value);
    const percentageNumber: number = parseFloat(parseFloat(String(Formatter.deleteExtraSpace(percentage)).replace(",", ".")).toFixed(2));
    const newTemplateArr = this.state.chargeTemplates?.map(template => {
      if (template?.id === id) {
        const newAmount = template?.oldAmount + template?.oldAmount * (percentageNumber / 100);
        template.editedAmount = isNaN(newAmount) ? 0 : this.formatter.simpleFormatNumber(newAmount * 100);
        template.percentage = percentage;
        template.buttonDisabled = false;
      }
      return template
    })

    this.setState({
      chargeTemplates: newTemplateArr
    });
  }

  public updatePrice = (id) => {
    const newTemplateArr = this.state.chargeTemplates?.map(template => {
      if (template?.id === id) {
        template.isChanged = true;
        template.amount = parseFloat(parseFloat(String(Formatter.deleteExtraSpace(template.editedAmount)).replace(",", ".")).toFixed(2));
        template.buttonDisabled = true;
      }
      return template
    })

    this.setState({
      disableNextButton: false,
      chargeTemplates: newTemplateArr
    })

  }

  public getPayloadTenant = (): any => {
    const pageTemplate = "tenant";

    return {
      person: {
        firstName: this.state.tenantFirstName,
        lastName: this.state.tenantLastName,
        profession: "",
        email: "",
        phone1: "",
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: "",
        pageTemplate: pageTemplate,
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      }
    };
  }

  public getPayloadForPerson = (type): any => {
    let pageTemplate = type;
    return {
      firstName: type === "tenant" ? this.state.tenantFirstName : this.state.firstName,
      lastName: type === "tenant" ? this.state.tenantLastName : this.state.lastName,
      profession: "",
      email: "",
      phone1: "",
      phone2: "",
      contactRoleId: null,
      mainBankAccountId: "",
      companyId: null,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: pageTemplate,
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
    };
  }

  public closePreprocessDilaogOpen = () => {
    this.setState({
      isClosePreprocessDialogOpen: false
    });
  }

  public isNextButtonDisabled = () => {
    if (this.state.activeStep === 0 && !this.state.contract) {
      return true
    }
    if ((this.state.activeStep === 1 && this.state.chargeTemplates?.length === 0) ||
      (this.state.activeStep === 1 && this.state.disableNextButton)
    ) {
      return true
    }
    if (this.state.activeStep === 2 && !this.state.extensionDate) {
      return true
    }
  }

  public render() {
    const steps = this.getSteps();
    return (
      <div>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          oldCoach={true}
          content={(activeStep) => this.getStepContent(activeStep)}
          openCoach={this.state.openCoachIncreaseRent}
          onCloseCoach={this.onCloseIncreaseRentCoach}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({ activeStep, isDisabled: false })
          }}
          showBackButton={true}
          disabled={false}
          disabledBack={false}
          disabledNext={this.isNextButtonDisabled()}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
